import { PaymentConnectorInterface } from '@/services/connectors/interfaces';
import PaymentMethodLiteral from '@/utils/paymentMethodLiteral';
import { customizingAPI, orderAPI, paymentAPI } from '@/services/http-service';
import store from '@/store';
import { AxiosResponse } from 'axios';
import { FormDataToken } from '@/models/BaseTypes';
import {
  PaymentRequest,
  PaymentUrlResponse,
} from '@/models/PaymentServiceRequest';

export default class PaymentConnector implements PaymentConnectorInterface {
  getBillingFrequencies(
    salesCampaignId: string,
    paymentMethod: PaymentMethodLiteral,
  ): Promise<AxiosResponse> {
    return customizingAPI.get(
      `salesCampaign/${salesCampaignId}/paymentMethod/${paymentMethod}/billingFrequencies`,
      { headers: { token: JSON.stringify(store.state.formDataToken) } },
    );
  }

  checkIbanSwift(iban: string, swift: string): Promise<AxiosResponse> {
    return orderAPI.post(
      'order/checkIbanSwift',
      {
        iban: iban,
        swift: swift,
      },
      { headers: { token: JSON.stringify(store.state.formDataToken) } },
    );
  }

  getPaymentAuthorizationUrl(
    data: PaymentRequest,
    formDataToken: FormDataToken | null,
  ): Promise<PaymentUrlResponse> {
    return paymentAPI
      .post('billing', data, {
        headers: { token: JSON.stringify(formDataToken) },
      })
      .then((response) => {
        return response.data;
      });
  }

  getPayOneParameters(
    formDataToken: FormDataToken | null,
  ): Promise<AxiosResponse> {
    return paymentAPI.get('parameters', {
      headers: { token: JSON.stringify(formDataToken) },
    });
  }
}
